import { z } from 'zod';
/** Recorded schedule identity, shared by report execution and saved-state reads. */
export const InstallationDay = z.object({
    id: z.string().min(1).max(200),
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine(v => { const d = new Date(v + 'T00:00:00Z'); return Number.isFinite(d.getTime()) && d.toISOString().slice(0, 10) === v; }, 'A recorded date is required'),
    crew: z.string().nullable().default(null), task: z.string().nullable().default(null),
});
/** This is an identity, not a security token. The server derives it from saved columns. */
export function installationDayKey(day) { return JSON.stringify([day.id, day.date, day.crew, day.task]); }
//# sourceMappingURL=installation-day.js.map